export default "52f87e0fd4efb94b.png"